const Layout = ({children}) => {
    return (
        <>
            <header>
                <h1>G-Code Commenter</h1>
            </header>
            <main>
                {children}
            </main>
        </>
    )
}

export default Layout;